<template>
  <highcharts class="fit-highchart" :options="options" style="width: 100%" />
</template>

<script>
import { isEmpty } from '@/utils/basic';
import { map, cloneDeep } from 'lodash';
import { columnOptions } from '@/constants/chart-options';

export default {
  name: 'WSummaryColumnChartForAvailRate',
  data() {
    return {
      options: cloneDeep(columnOptions),
    };
  },
  methods: {
    setData(value) {
      this.options.tooltip = {
        followPointer: true,
        pointFormat: '{series.label} 장비 가동률: {point.y}%',
      };

      this.options.xAxis.categories = isEmpty(map) ? [' '] : map(value, 'label');
      this.options.chart.height = '175px';
      this.options.yAxis.max = 100;
      this.options.yAxis.tickInterval = 10;
      this.options.yAxis.labels.format = '{value}%';
      this.options.series = [
        {
          data: value,
        },
      ];
      this.options.legend = false;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/performance/node/summary/components/SummaryColumnChartForAvailRate.vue